const timelineData = [
  {
    title: "2015",
    content: "2015년 2월 26일 사단법인 한국창조경영인협회 설립허가"
  },
  {
    title: "2015",
    content:
      "연합뉴스 2015년 3월 25일 한국창조경영인협회 신창조인 인증식 사례발표 대회."
  },
  {
    title: "2015",
    content:
      "문화일보 2015년 3월 26일 최세규 창조경영인협회장 “창조경제, 중기(中企)와 민간이 나서야 성공”"
  },
  {
    title: "2015",
    content: "연합뉴스 2015년 4월 28일 한국창조경영인협회 신창조인 선정식 개최."
  },
  {
    title: "2015",
    content: "한국경제 2015년 4월 28일 한국창조경영인협회 ‘신창조인’ 51명 선정."
  },
  {
    title: "2015",
    content:
      "서울경제 2015년 4월 28일 (사) 한국창조경영인협회 신창조인 선정식 및 한국재능나눔대상 시상식 개최."
  },
  {
    title: "2015",
    content: "매일경제 2015년 4월 28일 한국창조경영인협회 신창조인 51명 선정."
  },
  {
    title: "2015",
    content:
      "연합뉴스 2015년 6월 1일 한국창조경영인협회, 창조경제 활성화 포럼 개최."
  },
  {
    title: "2015",
    content: "한국경제 2015년 6월 1일 창조경영인협회, 창조경제 활성화 포럼."
  },
  {
    title: "2015",
    content:
      "문화일보 2015년 6월 2일 “신창조인들 일자리 창출” 창조경영인협회, 활성화 대회."
  },
  {
    title: "2015",
    content:
      "연합뉴스 2015년 6월 10일 한국창조경영인협회. 신창조인 선정식 개최."
  },
  {
    title: "2015",
    content:
      "한국경제 2015년 6월 10일 ‘신창조인’에 박철호 박노식 이윤수 등 35명 선정."
  },
  {
    title: "2015",
    content:
      "서울경제 2015년 6월 10일 (사) 한국창조경영인협회, 신창조인 선정식 및 한국재능나눔대상 시상식 개최"
  },
  {
    title: "2015",
    content:
      "연합뉴스 2015년 7월 29일 2015 신창조인 선정식. 한국재능나눔대상 시상식 개최"
  },
  {
    title: "2015",
    content:
      "한국경제 2015년 7월 29일 한국창조경영인협회 신창조인 등 선정, 프리마호텔서 시상"
  },
  {
    title: "2015",
    content:
      "서울경제 2015년 7월 29일 2015 신창조인 선정식 및 한국재능나눔대상 시상식 개최"
  },
  {
    title: "2015",
    content:
      "연합뉴스 2015년 10월 21일 한국창조경영인협회, '창조미래지식포럼' 개최"
  },
  {
    title: "2015",
    content:
      "서울경제 2015년 10월 22일 (사)한국창조경영인협회, 창조미래지식포럼 유명환 전 외교통상부 장관 초청 특강"
  },
  {
    title: "2015",
    content:
      "연합뉴스 2015년 11월 20일 한국창조경영인협회, '창조미래지식포럼' 개최"
  },
  {
    title: "2015",
    content:
      "연합뉴스 2015년 12월 11일 2015 신창조인 선정식·한국재능나눔 연말대상 시상식"
  },
  {
    title: "2015",
    content:
      "한국경제 2015년 12월 11일 2015 신창조인 선정식 및 한국재능나눔 연말대상 시상식 열려"
  },
  {
    title: "2015",
    content:
      "서울경제 2015년 12월 11일 (사)한국창조경영인협회 '2015 신창조인 선정식 및 한국재능나눔 연말대상 시상식' 개최"
  },
  {
    title: "2016",
    content:
      "연합뉴스 2016년 2월 24일 정운찬 전 총리, 62차 창조미래지식포럼 특강"
  },
  {
    title: "2016",
    content:
      "한국경제 2016년 3월 17일 애터미(주) 박한길 회장, 63차 창조미래지식포럼서 특강"
  },
  {
    title: "2016",
    content:
      "국제뉴스 2016년 3월 17일 애터미 박한길 회장 '난관 극복하며 이룬 성공'"
  },
  {
    title: "2016",
    content:
      "한국경제 2016년 3월 28일   창조경영인상 수상자와 한국재능나눔대상 시상식 가져 MBN 2016년 3월 29일 한국창조경영인협, 2016 창조경영인 60명 선정"
  },
  {
    title: "2016",
    content:
      "한국경제 2016년 5월 20일 한국창조경영인협회, 창조미래지식포럼 개최"
  },
  {
    title: "2016",
    content:
      "한국경제 2016년 6월 16일 한국창조경영인협회, 이상봉 디자이너 창조미래지식포럼서 특강"
  },
  {
    title: "2016",
    content:
      "한국경제 2016년 6월 28일 '2016 상반기 창조경영인 에 이효율 풀무원식품 대표 등 33명 선정"
  },
  {
    title: "2016",
    content:
      "세계일보 2016년 6월 29일 (사)한국창조경영인협회, ‘창조경영인 선정식 및 한국재능나눔 대상 시상식’ 개최"
  },
  {
    title: "2017",
    content:
      "한국경제 2017년 3월 29일 (사)한국창조경영인협회 창조경영인 시상식 개최"
  },
  {
    title: "2017",
    content:
      "세계일보 2017년 6월 27일 2017년 상반기 재능나눔 공헌대상 창조경영인 시상식 개최"
  },
  {
    title: "2017",
    content: "한국경제 2017년 10월 24일 2017 창조혁신경영대상 시상식 개최"
  },
  {
    title: "2018",
    content:
      "와우티비 2018년 3월 28일 창조혁신경영대상&재능나눔공헌대상 시상식 개최"
  },
  {
    title: "2018",
    content:
      "한국경제 2018년 6월 26일 창조혁신경영대상 및 재능나눔공헌대상 시상식 개최"
  },
  {
    title: "2018",
    content: "한국경제 2018년 11월 28일 창조혁신경영대상 시상식 개최"
  },
  {
    title: "2019",
    content: "UNN 2019년 4월 30일 2019 한국을 빛낸 창조경영인 선정"
  },
  {
    title: "2019",
    content: "뉴스와이어 2019년 5월 17일 2019 문화예술 창조경영인 선정"
  },
  {
    title: "2019",
    content:
      "와우티비 2019년 11월 6일 2019하반기 재능나눔공헌대상&창조혁신경영대상 개최"
  },
  {
    title: "2019",
    content:
      "세계일보 2019년 11월 7일 2019년 하반기 창조혁신경영대상 시상식 개최"
  },
  {
    title: "2020",
    content: "리뉴얼 중입니다."
  },
  {
    title: "2021",
    content: "리뉴얼 중입니다."
  }
];

export default timelineData;
